$.fn.password = function() {
  var style = getComputedStyle(this[0]);
  if (!style.webkitTextSecurity) {
      $(this).attr('type', 'password');
  }
};